module.exports = __webpack_public_path__ + "8ce2eb78/img/pdf-icon.79f04a36.svg";